import { Typography, Stack } from '@mui/material';
import { useIntl } from 'react-intl';

import { theme } from '@verantos-dev/shared-styles';

export default function ConceptsUploadInstructions() {
  const intl = useIntl();

  return (
    <Stack direction={'column'} gap={2}>
      <Typography variant="body1" fontWeight={600} color={theme.palette.text.primary}>
        {intl.formatMessage({ id: 'conceptGroup.instructions.title' })}
      </Typography>
      <Typography variant="body1" color={theme.palette.text.secondary}>
        {intl.formatMessage({ id: 'conceptGroup.instructions.description' })}
      </Typography>
    </Stack>
  );
}
